export default __webpack_public_path__ + "static/image-huddle-landing-page-3ec412d0e194dc342e29dbe0c85ae7e0.png";